import { useState } from 'react';
import { isDoctorConfirmationAnOption } from './utils';
import { MiniInterviewType } from 'src/packages/polaris/types';
import useFeatureFlag from 'src/hooks/useFeatureFlag';
import { IS_LOCAL } from 'src/interviews/requests/settings';
import useGeolocation from 'src/hooks/useGeolocation';

const DX_CONFIRMATION_FEATURE_FLAG = 'growth-public-site-dx-confirmation-enabled';
const DX_CONFIRMATION_FEATURE_FLAG_INTERNATIONAL =
  'growth-public-site-dx-confirmation-enabled-international';

const useIsDoctorConfirmationEnabled = (interviewType: MiniInterviewType) => {
  const featureFlagEnabled = useFeatureFlag({
    flagName: DX_CONFIRMATION_FEATURE_FLAG,
    defaultValue: IS_LOCAL,
  });

  const internationalFeatureFlagEnabled = useFeatureFlag({
    flagName: DX_CONFIRMATION_FEATURE_FLAG_INTERNATIONAL,
    defaultValue: IS_LOCAL,
  });

  const userLocation = useGeolocation();
  const userIsInUS = userLocation?.country === 'United States';
  const enabledByLocation = userIsInUS ? true : internationalFeatureFlagEnabled;

  const [isEnabled] = useState(
    isDoctorConfirmationAnOption(interviewType) && featureFlagEnabled && enabledByLocation,
  );

  const chargeAmount = useFeatureFlag({
    flagName: 'growth-public-site-dx-confirmation-price',
    defaultValue: 1,
  });

  return {
    isEnabled,
    chargeAmount,
  };
};

export default useIsDoctorConfirmationEnabled;
